import React, { useState, useEffect } from 'react';
import moment from 'moment';
import LcLoading from '../../../../../components/Generic/LcLoading';
import LcIconLink from '../../../../../components/Generic/LcIconLink';
import SolicitationCommentService from '../../../../../services/SolicitationCommentService/SolicitationCommentService';
import SolicitationAttachmentService from '../../../../../services/SolicitationAttachmentService/SolicitationAttachmentService';
import EmailTemplateService from '../../../../../services/EmailTemplateService/EmailTemplateService';
import CustomerService from '../../../../../services/CustomerService/CustomerService';

import "./index.css";
import Parse from 'html-react-parser';
import LcIcon from '../../../../../components/Generic/LcIcon';
import { useSelector } from 'react-redux';
import { UserState } from '../../../../../store/reducers/userReducer';
import { MenuState } from '../../../../../store/reducers/menuReducer';
import { RootState } from '../../../../../store/index';
import Modal from '../../../../../components/Dialog/Modal';
import SolicitationDetailsAddAttachment from '../SolicitationDetailsAddAttachment';
import DocumentView from '../../../../../components/Generic/DocumentView';
import CommentTextBoxDraft from './CommentTextBoxDraft';
import CommentTextBoxDraftAttendant from '../../../../../components/Form/CommentTextBoxDraftAttendant';
import TextTools from "../../../../../services/TextTools/TextTools";
import { Menu } from '@szhsin/react-menu';
import { PPToggle } from 'processor-plataform-ui';
import { LastComment } from '../../../../../models/solicitation';
import LcTooltip from '../../../../../components/Generic/LcTooltip';

interface Props {
    solicitation: any,
    files?: any[],
    handleCommentSize?: Function,
    showIconAttendant?: boolean,
    attendant?: boolean,
    reloadComments?: boolean,
    changeReloadComments?: Function,
    visible?: boolean,
    tab?: number
}

interface Comments {
    attachment: any
    commentDate: string,
    commentType: number,
    cryptTag: any,
    email: any,
    externalEmails: any,
    id: number | null,
    idSolicitation: number,
    idUser: number,
    idWork: any,
    image: any
    isAttachment: any,
    nameUser: string | undefined,
    new: any,
    subjectWork: any,
    teamWork: any,
    templateId: any,
    text: string,
    workId: any
}

const SolicitationDetailsComments: React.FC<Props> = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const solicitationCommentService = new SolicitationCommentService(props);
    const solicitationAttachmentService = new SolicitationAttachmentService(props);
    const customerService = new CustomerService(props);
    const emailTemplateService = new EmailTemplateService(props);
    const dateTimeNow = new Date();
    const momentDateTimeNow = moment(dateTimeNow.toISOString());
    const [files, setFiles] = useState<any[]>([]);
    const [selectedRow, setSelectedRow] = useState<any>();
    const [lastComment, setLastComment] = useState<Comments>();
    const [loading, setLoading] = useState<boolean>(false);
    const [commentDates, setCommentDates] = useState<any[]>([]);
    const [comments, setComments] = useState<Comments[]>([]);
    const [commentsAux, setCommentsAux] = useState<Comments[]>([]);
    const [data, setData] = useState<string>("");
    const [attachment, setAttachment] = useState<any>([]);
    const [openAttachment, setOpenAttachment] = useState<boolean>(false);
    const [emailTemplates, setEmailTemplates] = useState<any[]>([]);
    const [commentsOpen, setCommentsOpen] = useState<boolean>(false);
    const [paddingBottom, setPaddingBottom] = useState<string>('');
    const [commentTypeList, setCommentsTypeList] = useState<number[]>([]);
    const util = new TextTools();

    useEffect(() => {
        if (props.solicitation) {
            if (!menu.showHelper) {
                load();
            }
        }
    }, [props.solicitation]);

    const load = async () => {
        setLoading(true);

        try {
            setEmailTemplates([]);
            await getComments(props.solicitation.id);
            props.attendant && await getEmailTemplates();
        }
        catch (error) {

        }

        setLoading(false);
    }

    useEffect(() => {
        if (props.reloadComments && props.reloadComments === true) {
            load();
            props.changeReloadComments && props.changeReloadComments();
        }
    }, [props.reloadComments])

    const getComments = async (solicitationId: number) => {
        setCommentDates([]);
        setComments([]);
        setFiles([]);

        try {
            const response: any = await solicitationCommentService.getCommentsWithAttachments(solicitationId, (props.attendant && props.attendant === true) ? "attendant" : "solicitation");

            let commentsOrdered = response.data.filter(x => x.text !== null && x.text !== "").sort((a: any, b: any) => a.commentDate.toLowerCase() < b.commentDate.toLowerCase() ? 1 : -1);
            let commentsReplaced = commentsOrdered;
            // let commentsReplaced = commentsOrdered.map((comment: Comments) => {
            //     return { ...comment, text: (/[\n|\n\r]/.test(comment.text) && !comment.text.includes('<p>')) ? comment.text.replace(/(?:\r\n|\r|\n)/g, "<br/>").replace(/(?!<b|<p|<s|[</])(?:<)/g, "") : comment.text }
            // });

            setComments([...commentsReplaced]);
            setCommentsAux([...commentsReplaced]);
            commentsDates(commentsOrdered);
        }
        catch (error) {
            console.warn(error);
            debugger
        }
    }

    useEffect(() => {
        if (props.handleCommentSize) props.handleCommentSize(comments.length);
    }, [comments]);

    useEffect(() => {
        if (menu.showHelper) {
            setComments([
                {
                    attachment: null,
                    commentDate: new Date().toISOString(),
                    commentType: 1,
                    cryptTag: null,
                    email: null,
                    externalEmails: null,
                    id: 999999999,
                    idSolicitation: 123456789,
                    idUser: Number(user.id),
                    idWork: null,
                    image: null,
                    isAttachment: false,
                    nameUser: user.name,
                    new: null,
                    subjectWork: null,
                    teamWork: null,
                    templateId: null,
                    text: "teste comentario",
                    workId: null,
                },
                {
                    attachment: {
                        attachmentDate: new Date().toISOString(),
                        attachmentType: 1,
                        description: "image-teste.png",
                        disabled: 0,
                        id: 123456789,
                        idSolicitation: 123456789,
                        idUser: Number(user.id),
                        idWork: null,
                        internalName: "https://via.placeholder.com/300.png",
                        originalName: "https://via.placeholder.com/300.png",
                        image: "https://via.placeholder.com/300.png",
                    },
                    commentDate: new Date().toISOString(),
                    commentType: 1,
                    cryptTag: null,
                    email: null,
                    externalEmails: null,
                    id: null,
                    idSolicitation: 123456789,
                    idUser: Number(user.id),
                    idWork: null,
                    image: null,
                    isAttachment: true,
                    nameUser: user.name,
                    new: null,
                    subjectWork: null,
                    teamWork: null,
                    templateId: null,
                    text: "image-teste.png",
                    workId: null,
                },
            ])

            setCommentDates([moment(new Date().toISOString()).format("YYYY-MM-DD")]);
        }
    }, [menu.showHelper])

    useEffect(() => {
        if (props.files) {
            setFiles(props.files)
        }
    }, [props.files])

    useEffect(() => {
        if (props.solicitation) {
            if (comments.length > 0 && (props.solicitation.idStatus === 6 || props.solicitation.idStatus === 7 || props.solicitation.idStatus === 8)) {
                const _lastComment = comments.filter(comment => comment.commentType === 4)[0];
                setLastComment(_lastComment || commentsAux[0]);
            }
        }
    }, [comments]);

    const getEmailTemplates = async () => {
        try {
            const customerResponse = await customerService.GetById(props.solicitation.idCustomer);
            const emailResponse = await emailTemplateService.getEmailTemplates(customerResponse.data[0].idBusinessUnit, props.solicitation.idServiceGroup);
            setEmailTemplates(emailResponse.data);
        }
        catch (error) {
            console.warn(error);
        }
    }

    const showImage = (attachmentDescription: string) => {
        if (attachmentDescription.endsWith(".png") || attachmentDescription.endsWith(".jpg") || attachmentDescription.endsWith(".jpeg")) return true;
        else return false;
    }

    const downloadAttachment = (attachment: any) => {
        solicitationAttachmentService.downloadAttachmentById(attachment);
    }

    const handleSaveComment = async (comment: any) => {
        setLoading(true);

        try {
            if (files.length > 0) {
                await submitAttachment(comment);
            }
            else {
                await solicitationCommentService.newComment(comment);
            }

            await load();
        }
        catch (error) {
            console.warn(error);
        }

        setLoading(false);
    }

    const submitAttachment = async (solicitation: any) => {
        for (let index = 0; index < files.length; index++) {
            try {
                await solicitationAttachmentService.sendFile(files[index], solicitation.idSolicitation, solicitation.commentType, Number(user.id), solicitation.text);
            }
            catch (error) {
                console.warn(error);
            }
        }

        setFiles([]);
    }

    const getContent = (data: string) => {
        if (data) {
            const dataTemp = data.split("base64");

            if (dataTemp.length === 1) {
                return dataTemp[0].slice(1);
            }
            else if (dataTemp.length > 1) {
                return dataTemp[1].slice(1);
            }
        }
    }

    // const getType = (attachmentName: string) => {
    //     if (attachmentName.toLowerCase().endsWith("pdf")) {
    //         return "application/pdf";
    //     }
    //     else if (attachmentName.toLowerCase().endsWith("txt")) {
    //         return "text/plain";
    //     }
    //     else if (attachmentName.toLowerCase().endsWith("png")) {
    //         return "image/png";
    //     }
    //     else if (attachmentName.toLowerCase().endsWith("jpeg") || attachmentName.toLowerCase().endsWith("jpg")) {
    //         return "image/jpeg";
    //     }
    //     else if (attachmentName.toLowerCase().endsWith("bmp")) {
    //         return "image/bmp";
    //     }
    //     else if (attachmentName.toLowerCase().endsWith("gif")) {
    //         return "image/gif";
    //     }
    //     else {
    //         return "Sem visualização";
    //     }
    // }

    const getType = (attachmentName: string): string => {
        const fileExtensions: { [key: string]: string } = {
            pdf: "application/pdf",
            txt: "text/plain",
            png: "image/png",
            jpeg: "image/jpeg",
            jpg: "image/jpeg",
            bmp: "image/bmp",
            gif: "image/gif",
        };

        const extension = attachmentName.toLowerCase().split('.').pop() || "";

        return fileExtensions[extension] || "Sem visualização";
    };

    const [openAddAttachment, setOpenAddAttachment] = useState<boolean>(false);

    const handleOk = (filesTemp: any[]) => {
        setFiles([...files, ...filesTemp]);
        setOpenAddAttachment(false);
    }

    const handleClose = () => {
        setOpenAddAttachment(false);
    }

    const handleData = (comment: any) => {
        setData(comment.attachment.image);
        setAttachment(comment.attachment);
        setOpenAttachment(true);
    }

    const handleCloseAttachment = () => {
        setOpenAttachment(false);
    }

    const getIconComment = (commentType: number): string => {
        const icons: string[] = [
            "ppi ppi-eye-off",
            "ppi ppi-eye",
            "ppi ppi-eye-off",
            "ppi ppi-mail",
        ];

        return icons[commentType] || "";
    };

    const getCommentTypeTooltip = (commentType: number) => {
        const tooltips = [
            "Visivel para o atendente somente",
            "Visivel para o solicitante",
            "Visivel para o atendente somente",
            "Email padrão",
        ];

        return tooltips[commentType] || "";
    };

    const handleOpenAddAttachment = () => {
        setOpenAddAttachment(true);
    }

    const handleFiles = (files: any[]) => {
        setFiles(files);
    }

    useEffect(() => {
        if (props.attendant) {
            setPaddingBottom((commentsOpen) ? '100px' : "");
        }
        else {
            setPaddingBottom((commentsOpen) ? '180px' : "50px");
            window.scrollTo(0, document.body.scrollHeight)
        }
    }, [commentsOpen, props.attendant, paddingBottom])

    const parseComment = (text) => {
        // var text_ = util.cleanCss(text);
        var text_ = text;
        text_ = (text_.includes("<body")) ? text_.replace("<body", "<body style=\"background-color: initial;\"") : text_;
        text_ = text_.replaceAll('htmlxmlns:x="urn:schemas-microsoft-com:office:excel"', "html");
        text_ = text_.replaceAll("\r\n", "");

        const textParse = text_.includes(".com.br>") || text_.includes(".com>") || text_.includes(".br>") || text_.includes(".care>") ? Parse(util.cleanOnlyEmailParse(text_)) : Parse((text_ + ' '));
        var arr: any[] = [].slice.call(textParse);

        arr = (textParse instanceof Array) ? [].slice.call(textParse) : [textParse];
        let countBr = 0;

        arr = arr.filter((x, index) => {

            if (arr.length - 1 === index) {
                countBr = 0;
            }
            else {
                countBr = (arr[index].type === "br" && arr[index + 1].type && arr[index + 1].type === "br") ? (countBr) + 1 : 0;
            }

            if (arr[index].type !== "br") {
                return x;
            }
            else if (countBr <= 5) {
                return x;
            }
        });

        return arr as JSX.Element[];
    }

    const alterSetCommentType = (value: number) => {
        if (commentTypeList.includes(value)) {
            let types = commentTypeList.filter(type => type != value);
            setCommentsTypeList([...types]);
        }
        else {
            setCommentsTypeList([...commentTypeList, value]);
        }
    }

    const commentsDates = (comments: Comments[]) => {
        let commentDatesTemp: any[] = [];
        let commentsOrdered = comments.filter(x => x.text !== null && x.text !== "").sort((a: any, b: any) => a.commentDate.toLowerCase() < b.commentDate.toLowerCase() ? 1 : -1);
        commentsOrdered.map((comment: any) => {
            const commentDate = moment(comment.commentDate).format("YYYY-MM-DD");
            let temp = commentDatesTemp.filter(commentTemp => commentTemp === commentDate);

            if (temp.length === 0) commentDatesTemp.push(commentDate);
        });

        setCommentDates([...commentDatesTemp]);
    }

    useEffect(() => {
        let commenstFilter: any = [];
        let commentDatesTemp: any[] = [];

        if (commentTypeList.length > 0) {
            commentTypeList.forEach(type => {
                let filtro = commentsAux.filter(i => i.commentType === type);
                commenstFilter.push(...filtro);
            });

            commentsDates(commenstFilter);
            setComments([...commenstFilter]);
        }
        else {
            commentsDates(commentsAux);
            setComments([...commentsAux]);
        }
    }, [commentTypeList])

    const localUrl = window.location.pathname;
    const [menuOpen, setMenuOpen] = useState<boolean>(false);

    return (
        <div className='divOrderDetailsCommentGeral'>
            <div id={"commentBody"} className={"commentBody"} style={{ paddingBottom: paddingBottom }}>
                <LcLoading loading={loading} label="Carregando...">
                    {
                        localUrl.includes('/Attendance') &&
                        <div style={{ display: 'flex', justifyContent: 'flex-end', height: '11.5px' }}>
                            <Menu
                                align='end'
                                onMenuChange={(e) => setMenuOpen(e.open)}
                                menuButton={
                                    <div className={"lciconlink"} style={{ backgroundColor: (menuOpen) ? "#cccccf" : "" }}>
                                        <LcTooltip
                                            trigger={"hover"}
                                            content={'Filtros'}
                                        >
                                            <i className={"link ppi ppi-filter"} style={{ color: (menuOpen) ? "#fff" : "" }} />
                                        </LcTooltip>
                                    </div>
                                }
                            >
                                <div style={{ display: 'flex', flexDirection: "column", padding: '15px' }}>
                                    <div style={{ padding: "2px" }}>
                                        <PPToggle
                                            toggled={commentTypeList.includes(1)}
                                            name={"Comentários externos"}
                                            title={"Comentários externos"}
                                            onChange={() => alterSetCommentType(1)}
                                        />
                                    </div>
                                    <div style={{ padding: "2px" }}>
                                        <PPToggle
                                            toggled={commentTypeList.includes(0)}
                                            name={"Comentários internos"}
                                            title={"Comentários internos"}
                                            onChange={() => alterSetCommentType(0)}
                                        />
                                    </div>
                                    <div style={{ padding: "2px" }}>
                                        <PPToggle
                                            toggled={commentTypeList.includes(3)}
                                            name={"E-mail padrão"}
                                            title={"E-mail padrão"}
                                            onChange={() => alterSetCommentType(3)}
                                        />
                                    </div>
                                    <div style={{ padding: "2px" }}>
                                        <PPToggle
                                            toggled={commentTypeList.includes(2)}
                                            name={"Comentários de trabalhos"}
                                            title={"Comentários de trabalhos"}
                                            onChange={() => alterSetCommentType(2)}
                                        />
                                    </div>
                                    <div style={{ padding: "2px" }}>
                                        <PPToggle
                                            toggled={commentTypeList.includes(4)}
                                            name={"Comentários conclusivos"}
                                            title={"Comentários conclusivos"}
                                            onChange={() => alterSetCommentType(4)}
                                        />
                                    </div>
                                </div>
                            </Menu>
                        </div>
                    }
                    {
                        comments && commentDates.map(date => {
                            const commentListTemp = comments.filter(comment => moment(comment.commentDate).format("YYYY-MM-DD") == date);
                            const currentDate = moment();
                            let dateMoment = moment(date).fromNow().charAt(0).toUpperCase() + moment(date).fromNow().slice(1);

                            if (dateMoment.includes('dias')) {
                                const daysDiff = currentDate.diff(date, 'days');
                                dateMoment = `Há ${daysDiff} dias`;
                            }

                            const dateDescription = (date === momentDateTimeNow.format("YYYY-MM-DD")) ? "Hoje" : dateMoment;

                            return (
                                <>
                                    <span className={'spanCommentsDate'}> {dateDescription} </span>
                                    <>
                                        {
                                            commentListTemp.map(comment => {
                                                return (
                                                    <div className={'divOrderComments'} style={{ background: (lastComment && (comment.id === lastComment.id)) ? "#65ed83" : (comment.commentType === 2) ? "#2f62cd21" : "#FFFFFF" }}>
                                                        {
                                                            (lastComment && (comment.id === lastComment.id)) &&
                                                            <div className={'divOrderCommentUserIcon'}>
                                                                <LcIcon icon={"ppi ppi-flag"} size={'small'} color={'white'} />
                                                                <span className={'spanCommentsUser'} style={{ color: "white" }}> {"Conclusão:"} </span>
                                                            </div>
                                                        }
                                                        <div className={'divOrderCommentUserDate'}
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                alignContent: 'center',
                                                                justifyContent: 'space-between',
                                                                flexWrap: 'nowrap',
                                                                flexDirection: 'row',
                                                                width: '100%',
                                                                // overflow: 'hidden'
                                                            }}
                                                        >
                                                            <span className={'spanCommentsUser'}>
                                                                {
                                                                    (comment.cryptTag === "Attendant")
                                                                        ? `Atendente - ${comment.nameUser}`
                                                                        : `Solicitante - ${((comment.nameUser && comment.nameUser?.length > 20) ? comment.nameUser?.slice(0, 20) + "..." : comment.nameUser)}`
                                                                }
                                                            </span>
                                                            {
                                                                (window.screen.width > 600)
                                                                    ? <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <span className={'spanCommentsUser'} style={{ marginRight: '5px' }}>{`${moment(comment.commentDate).format('DD/MM/YY')} às ${moment(comment.commentDate).format('HH:mm')}`}</span>

                                                                        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                                                            {
                                                                                (window.location.pathname !== "/" && comment.commentType === 2)
                                                                                    ? <LcIcon icon={"ppi ppi-desktop-computer"} size={'small'} color={'rgb(137, 141, 166)'} />
                                                                                    : <LcIcon icon={"ppi ppi-user"} size={'small'} color={'rgb(137, 141, 166)'} />
                                                                            }
                                                                        </div>
                                                                        {
                                                                            props.showIconAttendant &&
                                                                            <LcIcon
                                                                                icon={(comment.attachment) ? getIconComment(comment.attachment.attachmentType) : getIconComment(comment.commentType)}
                                                                                size={"small"}
                                                                                color={"#898DA6"}
                                                                                tooltip={getCommentTypeTooltip(comment.commentType)}
                                                                                tooltipPosition={"fullLeft"}
                                                                            />
                                                                        }
                                                                    </div>
                                                                    : <>
                                                                        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                                                            <span className={'spanCommentsUser'}>{`${moment(comment.commentDate).format('DD/MM/YYYY')} às ${moment(comment.commentDate).format('HH:mm')}`}</span>
                                                                            {
                                                                                (window.location.pathname !== "/" && comment.commentType === 2)
                                                                                    ? <LcIcon icon={"ppi ppi-desktop-computer"} size={'small'} color={'rgb(137, 141, 166)'} />
                                                                                    : <LcIcon icon={"ppi ppi-user"} size={'small'} color={'rgb(137, 141, 166)'} />

                                                                            }
                                                                        </div>
                                                                        {
                                                                            props.showIconAttendant &&
                                                                            <LcIcon
                                                                                icon={(comment.attachment) ? getIconComment(comment.attachment.attachmentType) : getIconComment(comment.commentType)}
                                                                                size={"small"}
                                                                                color={"#898DA6"}
                                                                                tooltip={getCommentTypeTooltip(comment.commentType)}
                                                                                tooltipPosition={"fullLeft"}
                                                                            />
                                                                        }
                                                                    </>
                                                            }
                                                        </div>

                                                        {
                                                            (comment.attachment)
                                                                ? <div className={'divOrderAttachment'}
                                                                    onMouseEnter={() => setSelectedRow(comment)} onMouseLeave={() => setSelectedRow([])}
                                                                >
                                                                    <span className={'spanCommentsContent'}> {parseComment(util.cleanOnlyEmailParse(comment.text ?? ""))} </span>
                                                                    {
                                                                        showImage(comment.attachment.originalName)
                                                                            ? <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center" }}>
                                                                                {
                                                                                    <div style={{
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center'
                                                                                    }}>
                                                                                        {
                                                                                            selectedRow === comment &&
                                                                                            <div className='divIcons' style={{ position: 'absolute' }}>
                                                                                                <div style={{ marginRight: "20px" }}>
                                                                                                    <LcIconLink icon={"ppi ppi-document-download"} size={'big'} onClick={() => downloadAttachment(comment.attachment)} />
                                                                                                </div>

                                                                                                <LcIconLink icon={"ppi ppi-document-search"} size={'big'} onClick={() => handleData(comment)} />
                                                                                            </div>
                                                                                        }
                                                                                        <img
                                                                                            className={'imgAttachment'}
                                                                                            src={comment.attachment.image}
                                                                                            alt=""
                                                                                            style={{
                                                                                                position: 'relative',
                                                                                                opacity: (selectedRow === comment) ? "0.3" : "1",
                                                                                                // marginTop: (selectedRow === comment) ? "-42px" : "",
                                                                                                minWidth: "300px",
                                                                                                maxWidth: (props.attendant && props.attendant === true) ? "600px" : "300px",
                                                                                                maxHeight: (props.attendant && props.attendant === true) ? "calc(100% - 300px)" : "200px",
                                                                                                minHeight: "100px",
                                                                                            }}
                                                                                            onClick={() => handleData(comment)}
                                                                                        />
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                            : (
                                                                                getType(comment.attachment.internalName) !== "Sem visualização"
                                                                                    ? <>
                                                                                        <iframe
                                                                                            allowTransparency={true}
                                                                                            title={comment.attachment.originalName}
                                                                                            src={`data:${getType(comment.attachment.internalName)};charset=utf-8;base64,${getContent(comment.attachment.image)}`}
                                                                                            style={{
                                                                                                width: (props.attendant && props.attendant === true) ? "100%" : "",
                                                                                                height: (props.attendant && props.attendant === true) ? "300px" : "",
                                                                                            }}>
                                                                                            <embed src={`text/html;charset=utf-8;base64,${getContent(comment.attachment.image)}`} type={getType(comment.attachment.internalName)} />
                                                                                        </iframe>
                                                                                        <div
                                                                                            style={{
                                                                                                display: "flex",
                                                                                                flexDirection: "row",
                                                                                                flexWrap: "wrap",
                                                                                                justifyContent: 'center',
                                                                                                width: (props.attendant && props.attendant === true) ? "80vw" : "100%",
                                                                                                // left: "96.5px",
                                                                                            }}>
                                                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                                <LcIconLink icon={"ppi ppi-document-download"} size={'big'} onClick={() => downloadAttachment(comment.attachment)} />
                                                                                                {/* <LcIconLink icon={"ppi ppi-document-search"} size='big' onClick={() => handleData(comment)} /> */}
                                                                                            </div>
                                                                                        </div>
                                                                                    </>
                                                                                    : <>
                                                                                        <LcIconLink icon={"ppi ppi-document-download"} size={'big'} onClick={() => downloadAttachment(comment.attachment)} />
                                                                                        <span className={'spanCommentsContent'}> {comment.attachment.originalName} </span>
                                                                                    </>
                                                                            )
                                                                    }
                                                                </div>
                                                                : <span className='spanCommentsContent'> {parseComment(comment.text ?? "")} </span>
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </>
                                </>
                            )
                        })
                    }
                    {
                        props.solicitation && (props.solicitation.idStatus !== 6 && props.solicitation.idStatus !== 7 && props.solicitation.idStatus !== 8) &&
                        <>
                            {
                                props.attendant
                                    ? <CommentTextBoxDraftAttendant
                                        tab={props.tab}
                                        solicitation={props.solicitation}
                                        attendant={(props.attendant) ? props.attendant : undefined}
                                        commentsLength={comments.length}
                                        handleOpenAddAttachment={handleOpenAddAttachment}
                                        files={files}
                                        handleFiles={handleOk}
                                        removeFiles={handleFiles}
                                        handleSaveComment={handleSaveComment}
                                        emailTemplates={emailTemplates}
                                        attendantType={props.attendant}
                                        setOpen={setCommentsOpen}
                                        comments={comments}	
                                    />

                                    : <CommentTextBoxDraft
                                        tab={props.tab}
                                        solicitation={props.solicitation}
                                        attendant={(props.attendant) ? props.attendant : undefined}
                                        commentsLength={comments.length}
                                        handleOpenAddAttachment={handleOpenAddAttachment}
                                        files={files}
                                        handleFiles={handleOk}
                                        removeFiles={handleFiles}
                                        handleSaveComment={handleSaveComment}
                                        emailTemplates={emailTemplates}
                                        attendantType={props.attendant}
                                        setOpen={setCommentsOpen}
                                    />
                            }
                        </>
                    }

                    <Modal title={"Anexar arquivo"} visible={openAddAttachment} close={() => setOpenAddAttachment(false)}>
                        <SolicitationDetailsAddAttachment handleOk={handleOk} handleClose={handleClose} />
                    </Modal>

                    <DocumentView
                        data={data}
                        downloadAttachment={downloadAttachment}
                        attachment={attachment}
                        handleCloseAttachment={handleCloseAttachment}
                        openAttachment={openAttachment}
                    />
                </LcLoading>
            </div>
        </div>
    );
};

export default SolicitationDetailsComments;